<template>

    <div>
        <settingsNav></settingsNav>
        <v-container>

            <v-layout row wrap>

                <v-flex xs12 sm12 mb-2>

                    <v-btn class="secondary white--text" @click.stop="openManufacturerDialog(null)">
                        New Manufacturer
                        <v-icon class="white--text" right>add</v-icon>
                    </v-btn>

                </v-flex>

            </v-layout>

            <v-layout row wrap>

                <v-flex xs12 sm12>
                    <v-layout row>
                        <v-flex xs12>

                            <v-card>
                                <v-card-title>
                                    <v-card-title class="headline">
                                        Manufacturers
                                    </v-card-title>
                                    <v-spacer></v-spacer>
                                    <v-text-field
                                            v-model="search"
                                            append-icon="search"
                                            label="Search"
                                            single-line
                                            hide-details
                                            clearable
                                    ></v-text-field>
                                </v-card-title>

                                <v-data-table
                                        :headers="headers"
                                        :items="getManufacturers"
                                        :pagination.sync="pagination"
                                        :total-items=total
                                        class="elevation-0"
                                        :loading="loading"
                                        :rows-per-page-items="rowsPageItems"
                                >

                                    <template slot="headerCell" slot-scope="props">
                                        <v-tooltip bottom>
                                        <span slot="activator">
                                          {{ props.header.text }}
                                        </span>
                                            <span>
                                          {{ props.header.text }}
                                        </span>
                                        </v-tooltip>
                                    </template>
                                    <template slot="items" slot-scope="props">
                                      <v-touch tag="tr"
                                               @doubletap="openManufacturerDialog(props.item.id)"
                                               @dblclick="openManufacturerDialog(props.item.id)">
                                            <td>{{ props.item.id }}</td>
                                            <td class="text-xs-left">{{ props.item.name }}</td>
                                            <td class="text-xs-left">{{ props.item.website }}</td>
                                            <td class="text-xs-left">{{ props.item.email }}</td>
                                      </v-touch>
                                    </template>
                                </v-data-table>
                            </v-card>
                        </v-flex>

                    </v-layout>


                    <addManufacturerDialog></addManufacturerDialog>


                </v-flex>
            </v-layout>

        </v-container>
    </div>

</template>

<script>
    // Types
    import {
        Settings,
        ManufacturersSettings
    } from '../../../store/namespace-helper'

    import addManufacturerDialog from './AddManufacturerDialog.vue'
    import settingsNav from '../../Shared/SettingsNav.vue'
    import {stateHelperMixin} from '../../../mixins/stateHelperMixin'
    import _ from 'lodash'

    export default {
      name: 'manufacturers',
      components: {
        addManufacturerDialog,
        settingsNav
      },
      mixins: [stateHelperMixin],
      data () {
        return {
          isVisible: false,
          headers: [
                    {text: 'Manufacturer-ID', value: 'id'},
                    {text: 'Manufacturer Name', value: 'name'},
                    {text: 'Website', value: 'website'},
                    {text: 'E-Mail', value: 'email'}
          ],
          pagination: {},
          search: '',
          total: 0,
          onDismissed: false,
          rowsPageItems: [10, 25, 50, 100, 250]
        }
      },
      beforeDestroy () {
        this.resetStateBeforeLeaveRoute()
      },
      mounted () {
        this.loadManufacturers()
      },
      methods: {
        openManufacturerDialog (val) {
          if (val !== null) {
            let item = this.getManufacturers.find(x => x.id === val)
            this.$store.dispatch(ManufacturersSettings.actions.setSelectedManufacturer, item)
          }
          this.$store.dispatch(ManufacturersSettings.actions.openCloseNewManufacturerDialog)
        },
        loadManufacturers: function () {
          const {sortBy, descending, page, rowsPerPage} = this.pagination
          const query = {
            sortBy: sortBy || 'id',
            descending: descending ? 'desc' : 'asc',
            page: page || 1,
            limit: rowsPerPage !== -1 ? rowsPerPage : 0,
            search: this.search ? this.search : ''
          }
          this.$store.dispatch(ManufacturersSettings.actions.loadManufacturers, query)
        },
        throttledLoadManufacturers: _.debounce(function () {
          this.loadManufacturers()
        }, 450)
      },
      computed: {
        getManufacturers () {
          console.log('ManufacturersSettings.getters.manufacturers: ' + ManufacturersSettings.getters.manufacturers)
          this.total = this.$store.getters[ManufacturersSettings.getters.manufacturers].total
          return this.$store.getters[ManufacturersSettings.getters.manufacturers].data
        },
        dialogState () {
          return this.$store.getters[ManufacturersSettings.getters.getOpenNewManufacturerDialogState]
        },
        loading () {
          return this.$store.getters[Settings.getters.loading]
        },
        getNetworkError () {
          return this.$store.getters[Settings.getters.getNetworkError]
        }
      },
      watch: {
        pagination: {
          handler () {
            this.loadManufacturers()
          },
          deep: true
        },
        search: {
          handler (val) {
            this.throttledLoadManufacturers()
          },
          deep: true
        },
        dialogState: {
          handler (val) {
            if (!val) {
              this.throttledLoadManufacturers()
            }
          },
          deep: true
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Settings/Manufacturers/Manufacturers.vue